// Copyright (c) 2020 Deere & Company

import actions from '../action-list';

export const updateTemporaryObjectKey = temporaryObjectKey =>

    dispatch => {

        dispatch({
            temporaryObjectKey,
            type: actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_TEMPORARY_OBJECT_KEY
        });

    };



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-pdi/action-creators/update-temporary-object-key.js